export default __webpack_public_path__ + "static/media/landmark.db1a7974.svg";